<template>
  <el-menu v-if="obj" :default-active="active" class="menu_container">
    <el-sub-menu :show-timeout="1000" :index="items.nodeId" v-for="items in obj" :key="items.nodeName">
      <template #title>
        <span>{{ items.nodeName }}</span>
      </template>
      <template v-if="items.children">
        <el-menu-item :index="item.nodeId" v-for="item in items.children">
          <template v-if="item.nodeName.length>17">
            <el-tooltip :content="item.nodeName" placement="bottom" effect="light">
              <div class="menu_item" @click="treeItemClick(item)">{{ item.nodeName }}</div>
            </el-tooltip>
          </template>
          <div v-else class="menu_item" @click="treeItemClick(item)">{{ item.nodeName }}</div>
        </el-menu-item>
      </template>
    </el-sub-menu>
  </el-menu>
</template>

<script setup>
  import { ElMenu, ElSubMenu, ElMenuItem, ElTooltip } from 'element-plus';
  import { toRefs } from 'vue';

  const emits = defineEmits();
  const props = defineProps({
    obj: { type: Array, default: [] },
    active: { type: String, default: '' },
  });
  const { obj, active } = toRefs(props);

  const treeItemClick = (item) => {
    emits('treeItemClick', item);
  };
</script>

<style lang="less" scoped>
  .menu_container {
    border-right: none;
    .menu_item {
      flex: 1;
      color: #666;
    }

    :deep(.el-sub-menu__title) {
      height: 44px;
      padding-right: 35px;
      color: #333;
      font-size: var(--base-font-size);
      font-weight: 600;
      background-color: var(--bg-color);
    }

    :deep(.el-menu) {
      background-color: var(--bg-color);
    }

    :deep(.el-menu-item) {
      height: 44px;
      padding-left: 0 !important;
      padding-right: 0;
      line-height: 44px;
      text-indent: 3em;
      color: #666;
      font-size: var(--base-font-size);
      overflow: hidden;
      &.is-active {
        background-color: var(--light-color);
        .menu_item {
          color: #fff;
        }
      }
    }
  }
</style>